import React from 'react';
import PropTypes from 'prop-types';
import { CMS } from '../../utils/CMS';

export const ErrorMessage = ({ message, type, icon, messages }) => {
    return (
        <div className={`odf-message-inline ${type}`}>
            <div className="odf-message-icon odf-space-inner-right-s odf-space-inner-bottom-xs odf-icon-2xl">
                <i className={`odf-icon ${icon}`} />
            </div>
            <div className="odf-message-content">
                <span className="odf-message-title odf-text-md">
                    { messages && messages.length
                        ? messages.map((message) => (
                            <div key={message.key}>
                                <CMS id={message.key} values={message.values || {}} dangerouslySetInnerHTML={message.dangerouslySetInnerHTML} />
                            </div>
                        ))
                        : <CMS id={message} />
                    }
                </span>
            </div>
        </div>
    );
};

ErrorMessage.propTypes = {
    message: PropTypes.string,
    type: PropTypes.string,
    icon: PropTypes.string,
    messages: PropTypes.arrayOf(PropTypes.object),
};

ErrorMessage.defaultProps = {
    type: 'odf-message-informative-highlight',
    icon: 'odf-icon-information',
    messages: [],
};
